"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProfileCreateDto = void 0;
const class_validator_1 = require("class-validator");
var PaymentProfileCreateDto;
(function (PaymentProfileCreateDto) {
    class Request {
    }
    __decorate([
        (0, class_validator_1.IsString)(),
        (0, class_validator_1.IsNotEmpty)(),
        __metadata("design:type", String)
    ], Request.prototype, "name", void 0);
    __decorate([
        (0, class_validator_1.Matches)("^(\\d{12}|\\d{10})$"),
        __metadata("design:type", String)
    ], Request.prototype, "inn", void 0);
    __decorate([
        (0, class_validator_1.Matches)("^(\\d{9})$"),
        __metadata("design:type", String)
    ], Request.prototype, "kpp", void 0);
    PaymentProfileCreateDto.Request = Request;
})(PaymentProfileCreateDto || (exports.PaymentProfileCreateDto = PaymentProfileCreateDto = {}));
//# sourceMappingURL=payment-profile-create.dto.js.map